import isDOM from './isDOM';

/**
 * @private
 */
const SELECT = /select/i;
const TEXTAREA = /textarea/i;
const TEXT = /text|password|file|number|search|tel|url|email|datetime|datetime-local|date|time|month|week/i;
const RADIO = /checkbox|radio/i;
const INPUT = /input/i;

/**
 * @public
 *
 * This object contains methods to determine the type of a FORM element.
 * If you provide an argument that is not a DOM Element, or is not any of
 * the FORM fields, the methods below will return false.
 *
 * The methods exposed are: `{isWritable, isCheckable, isSelectable}`.
 * All of them receive a single argument which is the object to be
 * tested against a DOM Element and the FORM field.
 */
const fieldType = {
  isWritable: (dom) => {
    if (!isDOM(dom)) return false;
    if (TEXTAREA.test(dom.nodeName)) return true;
    return TEXT.test(dom.type) && INPUT.test(dom.nodeName);
  },
  isCheckable: (dom) => {
    if (!isDOM(dom)) return false;
    return RADIO.test(dom.type) && INPUT.test(dom.nodeName);
  },
  isSelectable: (dom) => {
    if (!isDOM(dom)) return false;
    return SELECT.test(dom.nodeName);
  },
};

export default fieldType;
